module.exports = __webpack_public_path__ + "img/vue2-toebox_rose.1c27dde9.png";